import { countryCodeList } from './const'
import {
  idsStringValidator,
  countriesStringValidator,
  validateIsPositiveNumber,
  validateIsImageUrl,
  validateIsUrl,
  positiveIntegerValidator,
  nonNegativeIntegerValidator,
  noMoreThanTenIdValidator,
} from './element-ui-form-validators'
import { i18n } from '../lang'

// replace `gb` with `uk`
export const countryList = [...countryCodeList]
const gbIndex = countryList.findIndex(code => code === 'gb')
countryList[gbIndex] = 'uk'

export const ServerToFormData = {
  convert(form) {
    if (form.enabled) {
      form.enabled = Boolean(form.enabled)
    }
    return form
  },
  getAvailableCountriesList(countries) {
    /*
      Example
      { hk: 1, uk: 0 } ---to---> ['hk']
    */
    return Object.keys(countries).reduce((acc, key) => {
      if (countryList.includes(key) && countries[key] === 1) {
        acc.push(key)
      }
      return acc;
    }, [])
  },
}

export const FormToServerFormat = {
  convert(form) {
    if (form.enabled) {
      form.enabled = Number(form.enabled)
    }
    return form
  },
  getCountryAvailabilityMap(countries) {
    /*
      Example
      ['hk] ---to---> { 'hk': 1', 'uk': 0, ... }
    */
    return countryList.reduce((acc, key) => {
      acc[key] = Number(countries.includes(key))
      return acc
    }, {})
  },
}

export const FormRules = {
  idList: { validator: idsStringValidator, trigger: 'blur' },
  countryList: { validator: countriesStringValidator, trigger: 'blur' },
  id: { validator: positiveIntegerValidator, trigger: 'blur' },
  positiveNumber: { validator: validateIsPositiveNumber, trigger: 'blur' },
  positiveInteger: { validator: positiveIntegerValidator, trigger: 'blur' },
  nonNegativeNumber: { validator: nonNegativeIntegerValidator, trigger: 'blur' },
  required: { required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' },
  requiredChange: { required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'change' },
  imageUrl: { validator: validateIsImageUrl, trigger: 'blur' },
  url: { validator: validateIsUrl, trigger: 'blur' },
  requiredCountries: {
    required: true, type: 'array', message: i18n.t('error.pleaseSelectCountry'), trigger: 'change',
  },
  maxNumOfId: { validator: noMoreThanTenIdValidator, trigger: 'blur' }
}

function langSuffixToKey(suffix) {
  let result = suffix
  if (result[0] === '_') {
    result = result.slice(1)
  }
  return result.toUpperCase()
}

function getLanguagesFromObject(object, attributeKey) {
  const languageList = []
  Object.keys(object).forEach((key) => {
    if (key.startsWith(attributeKey)) {
      // const suffix = key.slice(attributeKey.length)
      let suffix = ''
      if (key.slice(attributeKey.length)) {
        suffix = key.slice(attributeKey.length)
      } else {
        suffix = '_en'
      }
      const langKey = suffix ? langSuffixToKey(suffix) : 'EN'
      languageList.push({
        key: langKey,
        suffix,
      })
    }
  })
  return languageList
}

export function getLanguageList(formObject, attributeKey, objectKey) {
  /*
    @params
    input: form object
    key: key attribute of form data excluding lang suffix

    e.g. input {
      "breadcrumb": "",
      "description": "",
      "desscription_en_au": "",
      ...
    }

    e.g. input {
      ...,
      "description": {
        "value_zh_hk": "test test test",
        "value_zh_en": null,
      },
      ...
    }

    @return
    [
      { key: 'EN', suffix: '' },
      { key: 'EN_ID', suffix: '_en_id' },
      ...
    ]
  */

  if (formObject[attributeKey] && typeof formObject[attributeKey] === 'object') {
    return getLanguagesFromObject(formObject[attributeKey], objectKey)
  }
  return getLanguagesFromObject(formObject, attributeKey)
}

/*
 * Handler for table list retrieved from API in order to display on UI
 */
export const tableListHandler = (list) => {
  list.forEach((item) => {
    if (item.available_countries) {
      item.available_countries = Object.keys(item.available_countries).reduce((acc, key) => {
        if (item.available_countries[key] === 1) {
          acc.push(key)
        }
        return acc
      }, [])
    }
  })
  return list
}
